import api from "@/lib/api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Gera o relatório fotográfico em segundo plano (OS grandes estouram o timeout do proxy) e baixa ao terminar.
// onProgresso({feitas,total}) opcional. Lança Error com mensagem amigável em falha.
export async function gerarRelatorioFotografico(iniciarUrl, nomeArquivo, onProgresso) {
  const { data: job } = await api.post(iniciarUrl, null, { timeout: 60000 });
  let st = job; let falhas = 0;
  for (let i = 0; i < 900; i++) {              // até ~30 min
    await sleep(2000);
    try { ({ data: st } = await api.get(`/relatorios-fotograficos/jobs/${job.job_id}`, { timeout: 15000 })); falhas = 0; }
    catch (e) {
      if (e.response?.status === 404) throw new Error(e.response.data?.detail || "Geração expirou");
      if (++falhas >= 15) throw new Error("Sem resposta do servidor ao acompanhar a geração. Tente novamente.");
      continue;
    }
    onProgresso?.(st);
    if (st.status === "pronto") break;
    if (st.status === "erro") throw new Error(st.erro || "Falha ao gerar o PDF");
  }
  if (st.status !== "pronto") throw new Error("Tempo esgotado ao gerar o PDF");
  const r = await api.get(`/relatorios-fotograficos/jobs/${job.job_id}/download`, { responseType: "blob", timeout: 180000 });
  const url = URL.createObjectURL(r.data); const a = document.createElement("a");
  a.href = url; a.download = st.nome || nomeArquivo; a.click(); URL.revokeObjectURL(url);
  return st;
}
